<ng-container *t="let t">
    <div class="inside-container" *ngIf="availableFields && userDetails">
        <div fxLayout="row">
            <div fxFlex="70" fxLayoutAlign="start center">
                <h3
                    class="tab-header"
                    i18n="@@43161dab615da78790ff6e28f5730e88b96e21e0"
                    t="43161dab615da78790ff6e28f5730e88b96e21e0"
                    >Contact Details</h3
                >
                <a target="_blank" [href]="helpUrl">
                    <tsl-icon size="small" class="header-help-icon">help</tsl-icon>
                </a>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="5px">
            <div>
                <p *ngIf="isDataUnderReview">
                    <tsl-alert status="warning" class="spacing">
                        <h4 i18n="@@DataUnderReview" t="DataUnderReview">Data Changes Under Tesla Review</h4>
                        <br/>
                        <span i18n="@@DataUnderReviewDescription" t="DataUnderReviewDescription">
                            Submitted data changes are currently under review by Tesla. The ability to self-service in the Tesla Supplier Profile may be limited or restricted while your submission is being reviewed. Other aspects of the Supplier Relationship Management Portal should still be available to you based on your user access.
                        </span>
                    </tsl-alert>
                </p>
                <p *ngIf="userDetails.isSupplier">
                    <span
                        i18n="@@92add07f2579da0cdf8f17c0ccf1bff5100c3f6b"
                        t="92add07f2579da0cdf8f17c0ccf1bff5100c3f6b"
                        >The Supplier Contact Detail is available to users to manage their organizations contacts.
                        Supplier Profile core data changes, will go to Tesla for review and approval for validation
                        purposes.</span
                    ><br />
                    <b
                        ><span
                            i18n="@@99e6df02a2f598db23f2cfbe7201e16e082223cd"
                            t="99e6df02a2f598db23f2cfbe7201e16e082223cd"
                            >Please Note:</span
                        ></b
                    >
                    <span
                        i18n="@@b8cb135a86ec03289749d4d08636f2c59a1728e3"
                        t="b8cb135a86ec03289749d4d08636f2c59a1728e3"
                        >Only your organizations Primary Contact and Profile Admin can make contact changes. You will
                        receive emails in regards to rejections or approval of changes.</span
                    >
                </p>
                <p *ngIf="userDetails.isTeslaUser">
                    <span
                        i18n="@@96045ebe604470c37be8056e33e60414ee980571"
                        t="96045ebe604470c37be8056e33e60414ee980571"
                        >The Supplier Contact Detail is available to manage organizations contacts.</span
                    ><br />
                    <span
                        i18n="@@7445659469e1a219ce372682e7d182960a3c0dc8"
                        t="7445659469e1a219ce372682e7d182960a3c0dc8"
                        >Please go to </span
                    ><a
                        target="_blank"
                        [href]="wsmUrl"
                        i18n="@@2ccc81bcfcc7111f9e4427c178b6581a6134f634"
                        t="2ccc81bcfcc7111f9e4427c178b6581a6134f634"
                        >warp supplier master</a
                    >
                    <span
                        i18n="@@825d85e10720d106f01e81354a2126251f7beba4"
                        t="825d85e10720d106f01e81354a2126251f7beba4"
                        >to make any changes.</span
                    >
                </p>
                <p *ngIf="showCMTUrl">
                    <span
                        i18n="@@06e3ef7a1f084e3171d904619ae3c1e75e8f7979"
                        t="06e3ef7a1f084e3171d904619ae3c1e75e8f7979"
                        >If you have additional questions in regards to this data, click on the hyperlink provided to
                        submit a inquiry to the Tesla Vendor Validation Team. </span
                    ><a
                        [href]="cmtUrl"
                        i18n="@@217fe63d62f2a1b1443c6b307bad16b691a000b0"
                        t="217fe63d62f2a1b1443c6b307bad16b691a000b0"
                        >CMT</a
                    >
                </p>
            </div>
            <div *ngIf="settings?.showContactInquiryButton">
                <!-- todo ttp -->
                <button
                    tsl-button
                    size="small"
                    color="black"
                    outline
                    tooltip="Please reach out to Supplier Master Data Team if you have further inquiries in regards to your organizations contacts." 
                    i18n-tooltip="@@2176834273145566772" #contactInquiryButton tslTooltip="{{ t('2176834273145566772', contactInquiryButton) }}"
                    i18n="@@ContactInquiry"
                    t="ContactInquiry"
                    >Contact Inquiry</button
                >
            </div>
        </div>

        <div class="people internal-container">
            <tsl-tab-group [selectedIndex]="defaultTabIndex">
                <tsl-tab *ngIf="availableFields.includes('Manage Contacts')">
                    <ng-template tsl-tab-label>
                        <!-- todo ttp -->
                        <div
                            withArrow="true"
                            tslTooltipPosition="above"
                            tooltip="View and manage your organizations profile contact data" i18n-tooltip="@@4728670467950342444" #manageContacts tslTooltip="{{ t('4728670467950342444', manageContacts) }}"
                            i18n="@@256b0636a0f21e3e92b94a64b0771f19d845d0c9"
                            t="256b0636a0f21e3e92b94a64b0771f19d845d0c9"
                            >Manage Contacts</div
                        >
                    </ng-template>
                    <div class="internal-container">
                        <div *ngIf="this.userDetails">
                            <p
                                ><span
                                    i18n="@@df6b44703d4c4f2bd3e25d3eb215ddc541a71ec6"
                                    t="df6b44703d4c4f2bd3e25d3eb215ddc541a71ec6"
                                    >The Managing Contacts tab is an overview of your supplier profile contact data and
                                    the purposes or access needs of an individual contact within your organization to
                                    conduct business with Tesla on this portal.</span
                                >
                                <a
                                    style="cursor: pointer;"
                                    target="_blank"
                                    [href]="contactPurposeHelpUrl"
                                    i18n="@@e08ab51eb021005581058433cbac1a67b47ed5c7"
                                    t="e08ab51eb021005581058433cbac1a67b47ed5c7"
                                    >Contact Purposes
                                </a>
                            </p>
                            <manage-contact #manageContact *ngIf="this.supplierCode && this.userDetails">
                            </manage-contact>
                        </div>
                    </div>
                </tsl-tab>
                <tsl-tab *ngIf="availableFields.includes('Internal Job Roles')">
                    <ng-template tsl-tab-label>
                        <div
                            withArrow="true"
                            tslTooltipPosition="above"
                            i18n="@@InternalJobRoles"
                            t="InternalJobRoles"
                            >Internal Job Roles</div
                        >
                    </ng-template>
                    <div class="internal-container mat-elevation-z2">
                        <div class="right-container">
                            <button
                                tsl-button
                                [disabled]="preventativeHold==true"
                                color="black"
                                size="small"
                                outline
                                (click)="onAddJobRole()"
                                i18n="@@f9022ce8ef4820221f601820ef61220ec0be8166"
                                t="f9022ce8ef4820221f601820ef61220ec0be8166"
                                >Add Job Role</button
                            >
                        </div>
                        <table tsl-table [dataSource]="currentJobsPage" class="jobs">
                            <ng-container tslColumnDef="jobtitle">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@20d9489fdbfc121f7c504271b36691515d02f632"
                                    t="20d9489fdbfc121f7c504271b36691515d02f632"
                                    >Job Title
                                </th>
                                <td tsl-cell *tslCellDef="let job"> {{ translate.get(job.jobTitle) }} </td>
                            </ng-container>

                            <ng-container tslColumnDef="department">
                                <th tsl-header-cell *tslHeaderCellDef i18n="@@Department" t="Department">
                                    Department
                                </th>
                                <td tsl-cell *tslCellDef="let job"> {{ translate.get(job.department) }} </td>
                            </ng-container>

                            <ng-container tslColumnDef="action">
                                <th tsl-header-cell *tslHeaderCellDef i18n="@@Action" t="Action">
                                    Action
                                </th>
                                <td tsl-cell *tslCellDef="let item">
                                    <!-- todo ttp -->
                                    <button 
                                        tsl-icon-button
                                        [disabled]="preventativeHold==true"
                                        tooltip="Edit" i18n-tooltip="@@Edit" #editButton tslTooltip="{{ t('Edit', editButton) }}"
                                        (click)="onEditJobRole(item)"
                                    >
                                        <tsl-icon>edit</tsl-icon>
                                    </button>
                                    <!-- todo ttp -->
                                    <button
                                        tsl-icon-button
                                        [disabled]="preventativeHold==true"
                                        tooltip="Delete" i18n-tooltip="@@Delete" #deleteButton tslTooltip="{{ t('Delete', deleteButton) }}"
                                        (click)="onRemoveJobRole(item)"
                                    >
                                        <tsl-icon status="error">delete</tsl-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr tsl-header-row *tslHeaderRowDef="jobsColumns"></tr>
                            <tr tsl-row *tslRowDef="let row; columns: jobsColumns"></tr>
                        </table>

                        <tsl-pagination
                            [pageSizeOptions]="pageSizeOptions"
                            showFirstLastButtons
                            (pageChange)="onJobsPageChange($event)"
                            [total]="jobsResult?.length"
                            [itemsPerPageLabel]="translate.get('ItemsPerPage')"
                        ></tsl-pagination>
                    </div>
                </tsl-tab>
                <tsl-tab *ngIf="availableFields.includes('External Partners')">
                    <ng-template tsl-tab-label>
                        <div
                            withArrow="true"
                            tslTooltipPosition="above"
                            i18n="@@ExternalPartners"
                            t="ExternalPartners"
                            >External Partners</div
                        >
                    </ng-template>
                    <div class="internal-container mat-elevation-z2">
                        <div class="right-container">
                            <button
                                tsl-button
                                color="black"
                                outline
                                size="small"
                                (click)="onAddExternal()"
                                [disabled]="preventativeHold==true"
                                i18n="@@c8bf11482372c030a2dc340da3f43684f80d5d4b"
                                t="c8bf11482372c030a2dc340da3f43684f80d5d4b"
                                >Add External Partner</button
                            >
                        </div>
                        <table tsl-table [dataSource]="currentExternalsPage" class="externals">
                            <ng-container tslColumnDef="company">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@Company"
                                    t="Company"
                                    >Company
                                </th>
                                <td tsl-cell *tslCellDef="let item"> {{ item.companyName }} </td>
                            </ng-container>

                            <ng-container tslColumnDef="country">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@39413622819999e0b65a2ad27daf9ef6ea996dec"
                                    t="39413622819999e0b65a2ad27daf9ef6ea996dec"
                                >
                                    Country
                                </th>
                                <td tsl-cell *tslCellDef="let item"> {{ item.country?.abbreviation }} </td>
                            </ng-container>

                            <ng-container tslColumnDef="servicetype">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@f9d747247f3ed38606ef2ae220b3e20a59ad7ee1"
                                    t="f9d747247f3ed38606ef2ae220b3e20a59ad7ee1"
                                >
                                    Type of Service
                                </th>
                                <td tsl-cell *tslCellDef="let item"> {{ translate.get(item.serviceType) }} </td>
                            </ng-container>

                            <ng-container tslColumnDef="jobtitle">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@20d9489fdbfc121f7c504271b36691515d02f632"
                                    t="20d9489fdbfc121f7c504271b36691515d02f632"
                                    >Job Title
                                </th>
                                <td tsl-cell *tslCellDef="let item"> {{ translate.get(item.jobTitle) }} </td>
                            </ng-container>

                            <ng-container tslColumnDef="department">
                                <th tsl-header-cell *tslHeaderCellDef i18n="@@Department" t="Department"
                                    >Department
                                </th>
                                <td tsl-cell *tslCellDef="let item"> {{ translate.get(item.department) }} </td>
                            </ng-container>

                            <ng-container tslColumnDef="acreditations">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@6c19bf8876d4c04766640be257173debe7f454aa"
                                    t="6c19bf8876d4c04766640be257173debe7f454aa"
                                    >Has certifications
                                </th>
                                <td tsl-cell *tslCellDef="let item">
                                    <tsl-icon *ngIf="item.acreditations.length > 0">emoji_events</tsl-icon>
                                </td>
                            </ng-container>

                            <ng-container tslColumnDef="action">
                                <th tsl-header-cell *tslHeaderCellDef i18n="@@Action" t="Action">Action </th>
                                <td tsl-cell *tslCellDef="let item">
                                    <!-- todo ttp -->
                                    <button
                                        tsl-icon-button
                                        [disabled]="preventativeHold==true"
                                        tooltip="Edit" i18n-tooltip="@@Edit" #editExternalButton tslTooltip="{{ t('Edit', editExternalButton) }}"
                                        (click)="onEditExternal(item)"
                                    >
                                        <tsl-icon>edit</tsl-icon>
                                    </button>
                                    <!-- todo ttp -->
                                    <button
                                        tsl-icon-button
                                        [disabled]="preventativeHold==true"
                                        tooltip="Delete" i18n-tooltip="@@Delete" #deleteExternalButton tslTooltip="{{ t('Delete', deleteExternalButton) }}"
                                        tslTooltip="Delete"
                                        (click)="onRemoveExternal(item)"
                                    >
                                        <tsl-icon status="error">delete</tsl-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr tsl-header-row *tslHeaderRowDef="externalsColumns"></tr>
                            <tr tsl-row *tslRowDef="let row; columns: externalsColumns"></tr>
                        </table>

                        <tsl-pagination
                            [pageSizeOptions]="pageSizeOptions"
                            showFirstLastButtons
                            (pageChange)="onExternalsPageChange($event)"
                            [total]="externalsResult?.length"
                            [itemsPerPageLabel]="translate.get('ItemsPerPage')"
                        >
                        </tsl-pagination>
                    </div>
                </tsl-tab>
                <!--
                <tsl-tab *ngIf="availableFields.includes('Manage Contacts')">
                    <ng-template tsl-tab-label>
                        <div withArrow="true" tslTooltipPosition="above"
                        i18n-tslTooltip tslTooltip="View and manage your organizations Validation Task" i18n>
                            Validation Task</div>
                    </ng-template>
                    <div class="internal-container mat-elevation-z2">
                        <div *ngIf="this.userDetails && this.validationTask">
                            <p i18n>Our records indicate that a critical task for your Supplier Profile account has yet to be
                                validated. Please reach out to your organization's Primary Contact and confirm this task
                                is complete within the below due date. Or your portal account will be deactivated along
                                with other team members within your organization and all their portal access rights.</p>
                            <p> <u i18n>Please Note</u>: <ng-container i18n>Profile Accounts NOT validated by the due date will lose all portal
                                account access. Including critical portal functions; Shipping 2.0, Quality, FTA
                                Compliance, Carrier, E-Invoicing, Invoice Reports, and Supplier Profile.</ng-container></p>
                            <p><ng-container i18n>If you have any questions about these enhancements or the orientation process, please
                                contact</ng-container>
                                <a style="cursor: pointer;" target="_blank" href="mailto:vendorchanges@tesla.com" i18n>
                                    Supplier Management Team
                                </a>
                            </p>
                            <div>
                                <table>
                                    <tr>
                                        <th i18n>Primary Contact</th>
                                        <th i18n>Due Date</th>
                                        <th i18n>Status</th>
                                        <th i18n>Link</th>
                                    </tr>
                                    <tr>
                                        <td>{{validationTask.email}}</td>
                                        <td>{{validationTask.dueDateValue}}</td>
                                        <td>{{validationTask.status}}</td>
                                        <td><a *ngIf="this.userDetails.supplierContact && this.userDetails.supplierContact.emailId === this.validationTask.email"
                                                href="#" (click)="navigateToValidationTask()">Contact ValidationTask</a>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div *ngIf="this.userDetails && this.validationTask == null" i18n>
                            No validation task exist.
                        </div>
                    </div>
                </tsl-tab>
              -->
                <tsl-tab *ngIf="availableFields.includes('Manage Contacts')">
                    <ng-template tsl-tab-label>
                        <!-- todo ttp -->
                        <div
                            withArrow="true"
                            tslTooltipPosition="above"
                            tooltip="View and manage your organizations profile email domains" 
                            i18n-tooltip="@@546971964080077921" #manageEmailDomains tslTooltip="{{ t('546971964080077921', manageEmailDomains) }}"
                            i18n="@@1b117dbf2d8e324b1d28932b971b43a848c6d5e6"
                            t="1b117dbf2d8e324b1d28932b971b43a848c6d5e6"
                            >Manage Email Domains</div
                        >
                    </ng-template>
                    <div class="internal-container mat-elevation-z2">
                        <div *ngIf="this.userDetails">
                            <email-domain #emailDomain *ngIf="this.supplierCode && this.userDetails"> </email-domain>
                        </div>
                    </div>
                </tsl-tab>
            </tsl-tab-group>
        </div>
    </div>
</ng-container>
